<template>
  
    <div ref="slotInfoRef" class="flex flex-row justify-between items-center w-full h-full rounded-lg 
     :my-3 lg:p-2">

        <div class="absolute w-full" v-if="loading">
                
            <ring-loader class="rounded-full bg-red-500" ></ring-loader> 
        </div>

            <div v-if="isOnline" ref="descriptionPositionRef1" class="w-full flex flex-col h-full bg-purple100">
            
             <div class="flex mt-2 lg:mt-10 flex-col lg:flex-col justify-between pl-2 lg:pl-5 flex-grow 
                rounded overflow-scroll shadow w-full">
                
                <div class="flex flex-row sm:flex-col justify-between items-center lg:bg-blue-200 lg:mr-10 w-full
                lg:justify-around lg:rounded-r-full pr-1 lg:pr-4 lg:w-full">
                   
                    <div class="flex flex-row content-center justify-center items-center mb-2 lg:mb-5"> 
                        
                        <img :src="membership.class.business.logo"
                            class="object-contain rounded-full h-16 w-20 lg:h-32">	
                    </div>

                    <div class="flex flex-row lg:flex-col items-start cursor-pointer" @click="callModal()">

                        <div class="flex flex-row items-center mb-1 lg:mb-2 ml-2 lg:ml-5">
                
                            <img v-if="membership.class.image_1 !=''" :src="membership.class.image_1"
                                class="object-contain lg:w-1/4 ml-1 lg:ml-2 mt-1 lg:mt-2 w-10 h-10 lg:h-20">	
                            <img v-else :src="membership.class.business.logo"
                                class="object-contain lg:w-1/4 ml-1 lg:ml-2 mt-1 lg:mt-2 w-10 h-10 lg:h-20">	
                            
                            <img v-if="membership.class.image_2!=''" :src="membership.class.image_2"
                                class="object-contain lg:w-1/4 ml-1 lg:ml-2 mt-1 lg:mt-2 w-10 h-10 lg:h-20">	
                            <img v-else :src="membership.class.business.logo"
                                class="object-contain lg:w-1/4 ml-1 lg:ml-2 mt-1 lg:mt-2 w-10 h-10 lg:h-20">	

                            <img v-if="membership.class.image_3!=''" :src="membership.class.image_3"
                                class="object-contain lg:w-1/4 ml-1 lg:ml-2 mt-1 lg:mt-2 w-10 h-10 lg:h-20">	
                            <img v-else :src="membership.class.business.logo"
                                class="object-contain lg:w-1/4 ml-1 lg:ml-2 mt-1 lg:mt-2 w-10 h-10 lg:h-20">	

                            <img v-if="membership.class.image_4!=''" :src="membership.class.image_4"
                                class="object-contain lg:w-1/4 ml-1 lg:ml-2 mt-1 lg:mt-2 w-10 h-10 lg:h-20">	
                            <img v-else :src="membership.class.business.logo"
                                class="object-contain lg:w-1/4 ml-1 lg:ml-2 mt-1 lg:mt-2 w-10 h-10 lg:h-20">	
                        </div>
                    
                        <div class="flex flex-row items-center mb-1 lg:mb-2 ml-2 lg:ml-5">

                            <img v-if="membership.class.image_5!=''" :src="membership.class.image_5"
                                class="object-contain lg:w-1/4 ml-1 lg:ml-2 mt-1 lg:mt-2 w-10 h-10 lg:h-20">	
                            <img v-else :src="membership.class.business.logo"
                                class="object-contain lg:w-1/4 ml-1 lg:ml-2 mt-1 lg:mt-2 w-10 h-10 lg:h-20">	

                            <img v-if="membership.class.image_6!=''" :src="membership.class.image_6"
                                class="object-contain lg:w-1/4 ml-1 lg:ml-2 mt-1 lg:mt-2 w-10 h-10 lg:h-20">	
                            <img v-else :src="membership.class.business.logo"
                                class="object-contain lg:w-1/4 ml-1 lg:ml-2 mt-1 lg:mt-2 w-10 h-10  lg:h-20">	

                            <img v-if="membership.class.image_7!=''" :src="membership.class.image_7"
                                class="object-contain lg:w-1/4 ml-1 lg:ml-2 mt-1 lg:mt-2 w-10 h-10 lg:h-20">	
                            <img v-else :src="membership.class.business.logo"
                                class="object-contain lg:w-1/4 ml-1 lg:ml-2 mt-1 lg:mt-2 w-10 h-10lg:h-20">	

                            <img v-if="membership.class.image_8!=''" :src="membership.class.image_8"
                                class="object-contain lg:w-1/4 ml-1 lg:ml-2 mt-1 lg:mt-2 w-10 h-10 lg:h-20">	
                            <img v-else :src="membership.class.business.logo"
                                class="object-contain lg:w-1/4 ml-1 lg:ml-2 mt-1 lg:mt-2 w-10 h-10 lg:h-20">	
                        </div>
                    </div>
                </div>

                <div class="flex flex-col w-full">

                <div @dblclick="showDescription" ref="descriptionPositionRef1"
                 class="flex flex-row lg:flex-col bg-gray-100 items-center text-xs lg:text-sm w-full">
                    
                    <div class="flex lg:flex-col flex-row items-center">
                            
                        <div class="flex flex-col text-center px-3 pb-6 pt-2 lg:pt-4">
    
                            <div class="flex flex-row pb-2 lg:pb-4 items-center">
                                
                                <h3 class="text-black text-sm font-extrabold font-sans" >
                                <p class="text-pink-800 lg:pr-10 pr-1 w-20 me-2">{{$t('business.business')}} </p> </h3>
                                
                                <h3 class="text-black text-sm font-extrabold font-sans" >

                                <p class="border-purple-800 border-2 lg:border-4 rounded-full text-xs lg:text-lg w-40 lg:w-64 p-1"
                                > {{membership.class.business.name}} </p></h3>
                            </div>

                            <div class="flex flex-row pb-2 lg:pb-4 text-sm lg:text-xl items-center">
                                
                                <h3 class="text-black text-sm font-extrabold font-sans" >
                                <p class="text-pink-800 lg:pr-10 pr-1 w-20 me-2">{{$t('classes.class')}} </p> </h3>
                                
                                <h3 class="text-black  font-extrabold font-sans p-1" >

                                <p class="border-pink-800 border-2 lg:border-4 rounded-full w-40 lg:w-64 bg-green-400 text-sm lg:text-2xl p-1"
                                > {{membership.class.name}} </p></h3>
                            </div>
                            
                            <div class="flex flex-row justify-around text-xs lg:text-lg items-center">
                                
                                <h4 class="text-black text-sm font-extrabold font-sans">
                                <p class="text-purple-800 lg:pr-4 pr-1 w-20 me-2">{{$t('classes.instructor')}} </p></h4>
                                
                                <h4 class="text-black text-sm font-extrabold font-sans p-1">
                                 <p class="border-blue-700 border-double border-2 lg:border-4 
                                 rounded-fulltext-xs lg:text-xl w-40 lg:w-56">{{instructorName}}</p></h4>
                            </div>
                            
                        </div>
                    </div>

                    <div class="flex justify-center content-center rounder lg:rounded-lg">

                        <img  v-if="membership.instructor != null" :src="membership.instructor.logo"
                             class="object-contain h-20 lg:h-40 lg:w-64 rounded-full">

                        <img  v-else :src="membership.class.business.logo"
                        class="object-contain h-20 lg:h-40 lg:w-64 rounded-full">
                    </div>
                </div>

                <div @dblclick="showDescription"
                     class="w-screen flex flex-col items-center justify-around h-full pb-1 lg:pb-3 text-xs 
                     lg:text-lg text-grey-dark pt-2 lg:mr-24">
                    <div class="flex lg:flex-col flex-row w-full">

                        <div class="flex flex-col w-screen">
                            
                            <div class="flex flex-row pb-1 lg:pb-3 text-grey-dark lg:w-full lg:justify-center">
                                
                                <!-- <div class="text-center mr-1 lg:mr-3 p-1 lg:p-4 bg-yellow-400"> -->
                                <div class="text-center ms-2 p-1 lg:p-4 bg-yellow-400 mr-1 lg:mr-2">
                                    
                                    <span class="font-bold">{{$t('memberships.price')}}</span>

                                    <h2 class=" text-green-700">{{membership.price}}</h2>
                                </div>

                                <div class="lg:border-r">

                                </div>

                                <div class="text-center ml-2 p-1 lg:p-4 w-24 lg:w-48 bg-pink-300 pl-1 lg:pl-2 mr-1 lg:mr-2">
                                    
                                    <span class="font-bold">{{$t('classes.level')}}</span>

                                    <h2 class="text-pink-700">{{membership.class.level}}</h2>
                                </div>

                                <div class="text-center ml-2 p-1 lg:p-4 bg-green-300 mr-1 lg:mr-2">
                                    
                                    <span class="font-bold">{{$t('sessions.available')}}</span>

                                    <h2 class="text-pink-700">{{available}}</h2>
                                </div>
                            </div>

                            <div class="flex flex-row justify-around lg:w-full lg:justify-center text-xs lg:text-lg items-center">
                            
                                <h4 class="text-black text-sm font-sans p-1">
                                <p class="border-blue-700 border-double border-2 lg:border-4 
                                rounded-lg text-xs lg:text-md w-24 lg:w-56">{{membershipPeriod()}}</p></h4>

                                <h4 class="text-black text-sm  font-sans p-1">
                                <p class="border-blue-700 border-double border-2 lg:border-4 
                                rounded-lg text-xs lg:text-md w-24 lg:w-56">
                                {{membership.classes_number}} {{$t('memberships.noOfClasses')}}</p></h4> 
                                                                                            
                            </div>  
                        </div>


                        <div class="flex lg:w-full lg:justify-center">

                            <div class=" text-center px-1 lg:px-3 text-sm lg:text-lg pb-1 lg:pb-6 pt-1 lg:pt-2">
                                <h3 class="text-black text-sm font-extrabold font-sans" >
                                <p class="text-pink-800">{{$t('memberships.type/s')}}</p> <p class="text-sm lg:text-lg border-pink-800 border-2 lg:border-4 rounded-full"> </p>{{type}}</h3>
                            </div>

                            <div class=" text-center px-1 lg:px-3 text-sm lg:text-lg pb-1 lg:pb-6 pt-1 lg:pt-2">
                                <h3 class="text-black text-sm font-extrabold font-sans" >
                                <p class="text-pink-800">{{$t('memberships.facility/s')}}</p> <p class="text-sm lg:text-lg border-pink-800 border-2 lg:border-4 rounded-full"> </p>{{facility}}</h3>
                            </div>
                        </div>
                    </div>
                    
                   <div class="w-full">

                       <div v-for="(item, i) in membership.three_class_membership_to_schedules" :key="i" 
                       class="h-24 overflow-y-scroll">
                        
                        <membership-schedule-card :schedule="item.three_class_schedule"/>

                       </div>
                   </div>

                    <div class="flex">
                            
                        <div class="flex flex-col justify-around text-xs lg:text-lg items-center mt-1 -mb-1 lg:mt-2 lg:-mb-2">
                            
                            <h4 v-if="membership.males && membership.females" 
                            class="bg-pink-600 font-bold lg:font-extrabold font-sans text-white">
                            <p class="w-20 lg:w-32">{{$t('sessions.mixed')}}</p></h4>

                            <h4 v-else 
                            class="text-white font-bold lg:font-extrabold font-sans bg-black rounded lg:rounded-lg">
                            <p class="w-20 lg:w-32">{{$t('sessions.notMixed')}}</p></h4>
                        </div>   
                        
                        <div v-if="membership.class.business.is_private == true" class="ml-5 lg:ml-10 flex flex-row justify-around text-xs lg:text-lg items-center mt-1 -mb-1 lg:mt-2 lg:-mb-2">
                                
                            <h4  
                            class="bg-pink-600 font-bold lg:font-extrabold font-sans text-white">
                            <p class="w-20 lg:w-32">{{$t('sessions.private')}}</p></h4>
                        </div>   
                    </div>     
                </div>
             </div>
            </div>

            <div class="flex content-around justify-around rounded rounded-t-lg overflow-hidden mt-1 w-full">

                <!-- <div class="flex items-center">
                    <div>

                        <label >{{$t('sessions.rating')}}</label>
                    </div>
                    <div>

                        <label class="mt-2 lg:mt-5 p-1 bg-blue-300 rounded-lg border-blue-800 border-1"
                        v-if="membership.class.class_ratings_aggregate.aggregate.avg.rating">{{membership.class.class_ratings_aggregate.aggregate.avg.rating}}</label>
                    
                        <label class="mt-2 lg:mt-5 p-1 bg-blue-300 rounded-lg border-blue-800 border-1"
                        v-else>{{$t('sessions.noRating')}}</label>
                    </div>
                </div> -->
                <div v-if="subscriptionFinished">
                                                       
                    <button
                    class="mr-2 lg:mr-5 px-1 lg:px-4 py-2 bg-blue-500 shadow-lg border rounded-lg text-xs lg:text-md text-white w-32 lg:w-48    
                    uppercase font-semibold tracking-wider focus:outline-none focus:shadow-outline hover:bg-red-400 active:bg-red-400"
                        @click="callJoinAgain">  <label>{{$t('memberships.subscribeAgain')}}</label></button>
                </div>
                
                <div v-else-if="!joined">

                    <button
                    class="mr-2 lg:mr-5 px-1 lg:px-4 py-2 bg-red-500 shadow-lg border rounded-lg text-xs lg:text-md text-white w-32 lg:w-48    
                    uppercase font-semibold tracking-wider focus:outline-none focus:shadow-outline hover:bg-red-400 active:bg-red-400"
                        @click="callJoining"><label v-if="joined">{{$t('slot.cancel')}}</label>  <label v-else>{{$t('memberships.subscribe')}}</label> </button>
                </div>


                <div  v-else class="w-full flex justify-center items-center">
                    <label class="bg-pink-400"> {{$t('memberships.subscribed')}}</label>
                </div>
            </div>
        </div>

        <div v-else  ref="descriptionPositionRef2" class="w-full flex flex-col h-full">

         <div class="flex mt-2 lg:mt-10 flex-col lg:flex-col justify-between pl-2 lg:pl-5 flex-grow 
            rounded overflow-scroll shadow w-full">
                
                <div class="flex flex-row sm:flex-col justify-between items-center lg:bg-blue-200 lg:mr-10 w-full
                lg:justify-around lg:rounded-r-full pr-1 lg:pr-4 lg:w-full">
                   
                    <div class="flex flex-row content-center justify-center items-center mb-2 lg:mb-5"> 
                        
                        <img :src="membership.class.business.logo"
                                class="object-contain rounded-full h-16 w-20 lg:h-32">	
                    </div>

                    <div class="flex flex-row lg:flex-col items-start cursor-pointer" @click="callModal()">

                        <div class="flex flex-row items-center mb-1 lg:mb-2 ml-2 lg:ml-5">
                
                            <img v-if="membership.class.image_1 !=''" :src="membership.class.image_1"
                                class="object-contain lg:w-1/4 ml-1 lg:ml-2 mt-1 lg:mt-2 w-10 h-10 lg:h-20">	
                            <img v-else :src="membership.class.business.logo"
                                class="object-contain lg:w-1/4 ml-1 lg:ml-2 mt-1 lg:mt-2 w-10 h-10 lg:h-20">	
                            
                            <img v-if="membership.class.image_2!=''" :src="membership.class.image_2"
                                class="object-contain lg:w-1/4 ml-1 lg:ml-2 mt-1 lg:mt-2 w-10 h-10 lg:h-20">	
                            <img v-else :src="membership.class.business.logo"
                                class="object-contain lg:w-1/4 ml-1 lg:ml-2 mt-1 lg:mt-2 w-10 h-10 lg:h-20">	

                            <img v-if="membership.class.image_3!=''" :src="membership.class.image_3"
                                class="object-contain lg:w-1/4 ml-1 lg:ml-2 mt-1 lg:mt-2 w-10 h-10 lg:h-20">	
                            <img v-else :src="membership.class.business.logo"
                                class="object-contain lg:w-1/4 ml-1 lg:ml-2 mt-1 lg:mt-2 w-10 h-10 lg:h-20">	

                            <img v-if="membership.class.image_4!=''" :src="membership.class.image_4"
                                class="object-contain lg:w-1/4 ml-1 lg:ml-2 mt-1 lg:mt-2 w-10 h-10 lg:h-20">	
                            <img v-else :src="membership.class.business.logo"
                                class="object-contain lg:w-1/4 ml-1 lg:ml-2 mt-1 lg:mt-2 w-10 h-10 lg:h-20">	
                        </div>
                    
                        <div class="flex flex-row items-center mb-1 lg:mb-2 ml-2 lg:ml-5">

                            <img v-if="membership.class.image_5!=''" :src="membership.class.image_5"
                                class="object-contain lg:w-1/4 ml-1 lg:ml-2 mt-1 lg:mt-2 w-10 h-10 lg:h-20">	
                            <img v-else :src="membership.class.business.logo"
                                class="object-contain lg:w-1/4 ml-1 lg:ml-2 mt-1 lg:mt-2 w-10 h-10 lg:h-20">	

                            <img v-if="membership.class.image_6!=''" :src="membership.class.image_6"
                                class="object-contain lg:w-1/4 ml-1 lg:ml-2 mt-1 lg:mt-2 w-10 h-10 lg:h-20">	
                            <img v-else :src="membership.class.business.logo"
                                class="object-contain lg:w-1/4 ml-1 lg:ml-2 mt-1 lg:mt-2 w-10 h-10 lg:h-20">	

                            <img v-if="membership.class.image_7!=''" :src="membership.class.image_7"
                                class="object-contain lg:w-1/4 ml-1 lg:ml-2 mt-1 lg:mt-2 w-10 h-10 lg:h-20">	
                            <img v-else :src="membership.class.business.logo"
                                class="object-contain lg:w-1/4 ml-1 lg:ml-2 mt-1 lg:mt-2 w-10 h-10 lg:h-20">	

                            <img v-if="membership.class.image_8!=''" :src="membership.class.image_8"
                                class="object-contain lg:w-1/4 ml-1 lg:ml-2 mt-1 lg:mt-2 w-10 h-10 lg:h-20">	
                            <img v-else :src="membership.class.business.logo"
                                class="object-contain lg:w-1/4 ml-1 lg:ml-2 mt-1 lg:mt-2 w-10 h-10 lg:h-20">	
                        </div>
                    </div>
                </div>

                <div class="flex flex-col w-full">

                    <div @dblclick="showDescription" ref="descriptionPositionRef2" 
                    class="flex flex-row lg:flex-col bg-gray-100 items-center text-xs lg:text-sm w-full">
                        
                        <div class="flex lg:flex-col flex-row items-center">
                                
                            <div class="flex flex-col text-center px-3 pb-6 pt-2 lg:pt-4">
        
                                <div class="flex flex-row pb-2 lg:pb-4 items-center">
                                    
                                    <h3 class="text-black text-sm font-extrabold font-sans" >
                                    <p class="text-pink-800 lg:pr-4 pr-1 w-20 me-2">{{$t('business.business')}} </p> </h3>
                                    
                                    <h3 class="text-black text-sm font-extrabold font-sans" >

                                    <p class="border-purple-800 border-2 lg:border-4 rounded-full text-xs lg:text-lg w-40 lg:w-64 p-1"
                                    > {{membership.class.business.name}} </p></h3>
                                </div>

                                <div class="flex flex-row pb-2 lg:pb-4  text-sm lg:text-xl items-center">
                                    
                                    <h3 class="text-black text-sm font-extrabold font-sans" >
                                    <p class="text-pink-800 lg:pr-4 pr-1 w-20 me-2">{{$t('classes.class')}} </p> </h3>
                                    
                                    <h3 class="text-black  font-extrabold font-sans p-1" >

                                    <p class="border-pink-800 border-2 lg:border-4 rounded-full w-40 lg:w-64 bg-green-400 text-sm lg:text-2xl p-1"
                                    > {{membership.class.name}} </p></h3>
                                </div>
                                
                                <div class="flex flex-row justify-around text-xs lg:text-lg items-center">
                                    
                                    <h4 class="text-black text-sm font-extrabold font-sans">
                                    <p class="text-purple-800 lg:pr-4 pr-1 w-20 me-2">{{$t('classes.instructor')}} </p></h4>
                                    
                                    <h4 class="text-black text-sm font-extrabold font-sans p-1">
                                    <p class="border-blue-700 border-double border-2 lg:border-4 
                                    rounded-fulltext-xs lg:text-xl w-32 lg:w-56">{{instructorName}}</p></h4>
                                </div>
                            </div>
                        </div>

                        <div class="flex justify-center content-center rounder lg:rounded-lg">

                            <img  v-if="membership.instructor != null" :src="membership.instructor.logo"
                                class="object-contain h-20 lg:h-40 lg:w-64 rounded-full">

                            <img  v-else :src="membership.class.business.logo"
                            class="object-contain h-20 lg:h-40 lg:w-64 rounded-full">		
                        </div>
                    </div>

                    <div @dblclick="showDescription"
                     class="w-screen flex flex-col items-center justify-around h-full pb-1 lg:pb-3 text-xs 
                     lg:text-lg text-grey-dark pt-2 lg:mr-24">

                        <div class="flex lg:flex-col flex-row w-full">

                            <div class="flex flex-col w-screen">

                                <div class="flex flex-row pb-1 lg:pb-3 text-grey-dark lg:w-full lg:justify-center">
                                    
                                    <!-- <div class="text-center mr-1 lg:mr-3 p-1 lg:p-4 bg-yellow-400"> -->
                                    <div class="text-center ms-2 p-1 lg:p-4 bg-yellow-400 mr-1 lg:mr-2">
                                        
                                        <span class="font-bold">{{$t('memberships.price')}}</span>

                                        <h2 class=" text-green-700">{{membership.price}}</h2>
                                    </div>

                                    <div class="lg:border-r">

                                    </div>

                                    <div class="text-center ml-2 p-1 lg:p-4 w-24 lg:w-48 bg-pink-300 pl-1 lg:pl-2 mr-1 lg:mr-2">
                                        
                                        <span class="font-bold">{{$t('classes.level')}}</span>

                                        <h2 class="text-pink-700">{{membership.class.level}}</h2>
                                    </div>

                                    <div class="text-center ml-2 p-1 lg:p-4 bg-green-300 mr-1 lg:mr-2">
                                        
                                        <span class="font-bold">{{$t('sessions.available')}}</span>

                                        <h2 class="text-pink-700">{{available}}</h2>
                                    </div>
                                </div>

                                <div class="flex flex-row justify-around lg:w-full lg:justify-center text-xs lg:text-lg items-center">
                                
                                    <h4 class="text-black text-sm font-sans p-1">
                                    <p class="border-blue-700 border-double border-2 lg:border-4 
                                    rounded-lg text-xs lg:text-md w-24 lg:w-56">{{membershipPeriod()}}</p></h4>

                                    <h4 class="text-black text-sm  font-sans p-1">
                                    <p class="border-blue-700 border-double border-2 lg:border-4 
                                    rounded-lg text-xs lg:text-md w-24 lg:w-56">
                                    {{membership.classes_number}} {{$t('memberships.noOfClasses')}}</p></h4> 
                                                                                                
                                </div>  
                            </div>

                            <div class="flex lg:w-full lg:justify-center">

                                <div class=" text-center px-1 lg:px-3 text-sm lg:text-lg pb-1 lg:pb-6 pt-1 lg:pt-2">
                                    <h3 class="text-black text-sm font-extrabold font-sans" >
                                    <p class="text-pink-800">{{$t('memberships.type/s')}}</p> <p class="text-sm lg:text-lg border-pink-800 border-2 lg:border-4 rounded-full"> </p>{{type}}</h3>
                                </div>

                                <div class=" text-center px-1 lg:px-3 text-sm lg:text-lg pb-1 lg:pb-6 pt-1 lg:pt-2">
                                    <h3 class="text-black text-sm font-extrabold font-sans" >
                                    <p class="text-pink-800">{{$t('memberships.facility/s')}}</p> <p class="text-sm lg:text-lg border-pink-800 border-2 lg:border-4 rounded-full"> </p>{{facility}}</h3>
                                </div>
                            </div>

                        </div>
                        
                    <div class="w-full">

                        <div v-for="(item, i) in membership.three_class_membership_to_schedules" :key="i" 
                        class="h-24 overflow-y-scroll">
                            
                            <membership-schedule-card :schedule="item.three_class_schedule"/>

                        </div>
                    </div>

                        <div class="flex">

                                
                            <div class="flex flex-col justify-around text-xs lg:text-lg items-center mt-1 -mb-1 lg:mt-2 lg:-mb-2">
                                
                                <h4 v-if="membership.males && membership.females" 
                                class="bg-pink-600 font-bold lg:font-extrabold font-sans text-white">
                                <p class="w-20 lg:w-32">{{$t('sessions.mixed')}}</p></h4>

                                <h4 v-else 
                                class="text-white font-bold lg:font-extrabold font-sans bg-black rounded lg:rounded-lg">
                                <p class="w-20 lg:w-32">{{$t('sessions.notMixed')}}</p></h4>
                            </div>   
                            
                            <div v-if="membership.class.business.is_private == true" class="ml-5 lg:ml-10 flex flex-row justify-around text-xs lg:text-lg items-center mt-1 -mb-1 lg:mt-2 lg:-mb-2">
                                    
                                    <h4  
                                    class="bg-pink-600 font-bold lg:font-extrabold font-sans text-white">
                                    <p class="w-20 lg:w-32">{{$t('sessions.private')}}</p></h4>
                            </div>   
                        </div>     
                    </div> 
                </div>   
            </div>

            <div class="flex content-around justify-around rounded rounded-t-lg overflow-hidden mt-1 w-full">

                <!-- <div class="flex items-center">
                    <div>

                        <label >{{$t('sessions.rating')}}</label>
                    </div>
                    <div>

                        <label class="mt-2 lg:mt-5 p-1 bg-blue-300 rounded-lg border-blue-800 border-1"
                        v-if="membership.class.class_ratings_aggregate.aggregate.avg.rating">{{$t('sessions.rating')}}</label>
                        
                        <label class="mt-2 lg:mt-5 p-1 bg-blue-300 rounded-lg border-blue-800 border-1"
                         v-else>{{$t('sessions.noRating')}}</label>
                    </div>
                </div> -->

                <div v-if="subscriptionFinished">
                                       
                    <button
                    class="mr-2 lg:mr-5 px-1 lg:px-4 py-2 bg-blue-500 shadow-lg border rounded-lg text-xs lg:text-md text-white 32 lg:w-48    
                    uppercase font-semibold tracking-wider focus:outline-none focus:shadow-outline hover:bg-red-400 active:bg-red-400"
                        @click="callJoinAgain">  <label>{{$t('memberships.subscribeAgain')}}</label></button>
                </div>

                <div v-else-if="!joined">

                    <button
                    class="mr-2 lg:mr-5 px-1 lg:px-4 py-2 bg-red-500 shadow-lg border rounded-lg text-xs lg:text-md text-white w-32 lg:w-48    
                    uppercase font-semibold tracking-wider focus:outline-none focus:shadow-outline hover:bg-red-400 active:bg-red-400"
                        @click="callJoining"><label>{{$t('memberships.subscribe')}}</label></button>
                </div>


                <div v-else class="w-full flex justify-center items-center" >

                    <label class="bg-pink-400"> {{$t('memberships.subscribed')}}</label>
                </div>
            </div>
        </div>

        <div ref="popoverRef" v-bind:class="{'hidden': !popoverShow, 'block': popoverShow}" class="bg-pink-600 border-0 mb-3 block z-50 font-normal leading-normal text-sm max-w-xs text-left no-underline break-words rounded-lg">
                                    
            <div class="flex flex-col items-center justify-center">

                <div class="bg-pink-600 text-white opacity-75 font-semibold p-3 mb-0 border-b border-solid border-gray-200 uppercase rounded-t-lg">
                    {{$t('sessions.classDescription')}}
                </div>
                <div class="text-white p-3">
                    {{membership.class.description}}
                </div>

                <div>
                    <button class="bg-blue-400 text-white text-sm lg:text-lg rounded" @click="popoverShow=false">

                        {{$t('profile.close')}}
                    </button>
                </div>
            </div>
        </div>
            
    </div>
</template>

<script>

import { RingLoader } from 'vue-spinners-css';

import moment from 'moment';

import myUpdates from '../hasura/myUpdates';

import componentsHelpers from '../classes/componentHelpers';

import { createPopper } from '@popperjs/core';

import membershipScheduleCard from './MembershipScheduleCard'


export default {

    created(){

        this.checkingJoin();

        if(this.membership.class.instructor_name != ''){

                this.instructorName = this.membership.class.instructor_name;
        }

       else if(this.membership.class.instructor.name != ''){

            this.instructorName = this.membership.class.instructor.name;
        }
        this.setType();
        this.setFacility();
    },

    mounted(){
        
        this.isBgGreen = true;

        const dayDate = this.dayDate;

        for(let i = 0; i < 8; i++){

            this.cardImages.push(this.membership.class.image_1);
            this.cardImages.push(this.membership.class.image_2);
            this.cardImages.push(this.membership.class.image_3);
            this.cardImages.push(this.membership.class.image_4);
            
            this.cardImages.push(this.membership.class.image_5);
            this.cardImages.push(this.membership.class.image_6);
            this.cardImages.push(this.membership.class.image_7);
            this.cardImages.push(this.membership.class.image_8);
        }

    },

    components:{

        membershipScheduleCard,
                RingLoader

    },

    props: {


        setJoinedForBackgroundColor:{

            type: Function
        },

        disablePage: false,

        isOnline: false,

        userId: 0,

        dayDate: '',

        membership:{

            type: Object
        },

        businessInfo:{
      
            type: Object,
        },

        myReload: {

            type: Function
        },

        index: 0,

        join: {
            
            type: Function
        },

        joinAgain: {
            
            type: Function
        },

        changeCardView: {

            type: Function
        },

        displayModal: {

            type: Function
        },
    },

    methods:{

        membershipPeriod(){

            let period = '';            

            if(this.membership.in_years > 0){
                
                if(period != ''){

                    period = period + ', '
                }

                if(this.membership.in_years == 1){

                    period = period + `${this.membership.in_years} year`

                }else{

                    period = period + `${this.membership.in_years} years`
                }
            } 
            if(this.membership.in_months > 0){
                
                if(period != ''){

                    period = period + ', '
                }

                if(this.membership.in_months == 1){

                    period = period + `${this.membership.in_months} month`

                }else{

                    period = period + `${this.membership.in_months} months`
                }
            } 
            if(this.membership.in_days > 0){
                
                if(period != ''){

                    period = period + ', ';
                }

                if(this.membership.in_days == 1){

                    period = period + `${this.membership.in_days} day`;

                }else{

                    period = period + `${this.membership.in_days} days`;
                }
            } 
            if(this.membership.free_years > 0){
                
                if(period != ''){

                    period = period + ', ';
                }

                if(this.membership.free_years == 1){

                    period = period + `${this.membership.free_years} free year`;

                }else{

                    period = period + `${this.membership.free_years} free years`;
                }
            } 
            if(this.membership.free_months > 0){
                
                if(period != ''){

                    period = period + ', ';
                }

                if(this.membership.free_months == 1){

                    period = period + `+ ${this.membership.free_months} free month`;

                }else{

                    period = period + `${this.membership.free_months} free months`;
                }
            } 
            if(this.membership.free_days > 0){
                
                if(period != ''){

                    period = period + ', ';
                }

                if(this.membership.free_days == 1){

                    period = period + `+ ${this.membership.free_days} free day`;

                }else{

                    period = period + `+ ${this.membership.free_days} free days`;
                }
            }

            return period;
        },
        
        checkingJoin(){

            for (let i = 0; i < this.membership.three_user_class_memberships.length; i++){
            
            
                if(this.membership.three_user_class_memberships[i].user != null){

                    // console.log(`userId: ${this.membership.three_user_class_memberships[i].user.id}`);
                    // console.log(`this.userId: ${this.userId}`);

                    if (this.userId == this.membership.three_user_class_memberships[i].user.id)
                    {
                    
                        if(moment(this.membership.three_user_class_memberships[i].end_date).isBefore(moment(this.dayDate)))
                        {
                            
                            this.subscriptionFinished = true;
                        }else{

                            this.setIsJoined();
                        }
                    }
                }
            }
        },

        calculateJoined(){

            let subscribedUsers = 0;

            for (let i = 0; i < this.membership.three_user_class_memberships.length; i++){
            
                // console.log(`user: ${JSON.stringify(this.membership.three_user_ma_memberships[i])}`);

                // console.log(`dayDate: ${moment(this.dayDate)}`);
                // console.log(`end: ${moment(this.membership.three_user_ma_memberships[i].end_date)}`);

                // console.log(`is before: ${moment(this.membership.three_user_ma_memberships[i].end_date).isBefore(moment(this.dayDate), 'day')}`);
            
                if(this.membership.three_user_class_memberships[i].user != null){

                    // console.log(`userId: ${this.membership.three_user_ma_memberships[i].user.id}`);
                    // console.log(`this.userId: ${this.userId}`);

                    if(moment(this.membership.three_user_class_memberships[i].end_date).isBefore(moment(this.dayDate)))
                    {
                        
                    }else{

                        subscribedUsers++;
                    }
                }
            }

            return subscribedUsers;
        },

        toastIt(){

            const subOptions =  { 	 theme: "toasted-primary", position: "bottom-center", duration : 5000,
             keepOnHover: true, singleton:true };
            this.$toasted.clear();
            this.$toasted.info(this.membership.class.description, subOptions);
        },

        showDescription(){

            return;
            this.popoverShow = true;
            
            if(this.isOnline){

                new createPopper(this.$refs.descriptionPositionRef1, this.$refs.popoverRef, {
                placement: "bottom"
                });
            }else{

                new createPopper(this.$refs.descriptionPositionRef2, this.$refs.popoverRef, {
                placement: "bottom"
                });
            }
        },

        closePop(){

            this.popoverShow = false;
        },

        callModal(){

            this.modalImages = [];

            this.prepareImages(0);
            
            this.displayModal(this.modalImages);


        },

        prepareImages(i){

            if(i == 8){

                return;
            }
            else{

                if(this.cardImages[i] != ''){

                    this.modalImages.push(
                        {
                            business: `${this.membership.class.business.name}`,
                            class: `${this.membership.class.name}`,
                            image: this.cardImages[i]
                        }
                        );
                    
                    i = i + 1;
                    
                    this.prepareImages(i);
                }
                else{
                    
                    return;
                }
            }
        },

        setIsJoined(dayDate){
            
            // console.log(`in setIsJoined`);
            this.myDayDate = dayDate;

            this.joined = true;
            this.setJoinedForBackgroundColor(true);

        },

        setType(){
            
            const types = this.membership.class.categories;

            for(let i = 0; i < types.length; i++){

                if(i != types.length - 1){
                    
                    this.type = this.type + types[i].category.name + ', '
                }
                else {
                  
                  this.type = this.type + types[i].category.name;
                }
            }
            return this.type;
        },  

        setFacility(){
            
            const facilities = this.membership.three_class_membership_facilities;

            for(let i = 0; i < facilities.length; i++){

                if(i != facilities.length - 1){
                    
                    this.facility = this.facility + facilities[i].facility.name + ', '
                }
                else {
                  
                  this.facility = this.facility + facilities[i].facility.name;
                }
            }
            // console.log(`type is ${this.type}`);
            return this.facility;
        },

        callJoining(){

            if(this.disablePage == true){

                componentsHelpers.toastIt(this.$toasted, this.$t('sessions.yourProfileeIsNotComplete'), 1, 'bubble', true);
                return;
            }
            
            const joiningSuccessful = this.joiningSuccessful;

            if(this.joined){

                // if(confirm(this.$t('memberships.confirmCancelling'))){

                //     this.loading = true;
                // }
            }
            else if(confirm(this.$t('memberships.confirmJoining'))){

                this.loading = true;
                this.join(this.membership, this.index, joiningSuccessful);
            }
        },

        callJoinAgain(){

            const joiningSuccessful = this.joiningSuccessful;

            if(confirm(this.$t('memberships.confirmJoining'))){

                this.loading = true;
                this.joinAgain(this.membership, this.index, joiningSuccessful);
            }
        },

        makeCardJoined(){

            this.joined = true;
            this.setJoinedForBackgroundColor(true);

        },

        joiningSuccessful(value){

            this.loading = false;
            
            if(value == true){

                this.makeCardJoined();
                    
                if(this.available > 0){

                    this.available = this.available - 1;
                }
            }
            else{

                this.setJoinedForBackgroundColor(false);
            }
        },

        changeView(isMaximize, index){

            this.changeCardView(isMaximize, index);
        }
    },

  data: function(){

    return{

        loading:false,
        myDayDate: this.dayDate,
        startTime: moment(new Date(`1970/01/01 ${this.membership.start_time}`)).format('hh:mm A'),
        // startTime:  'startTime',
        endTime: moment(new Date(`1970/01/01 ${this.membership.end_time}`)).format('hh:mm A'),
        // endtime: 'endtime',
        isMaximize: true,
        joined: false,
        instructorName: '',
        filteredSlots: [],
        weekDays: '',
        edit: false,
        initiated: false, 
        type: '',   
        facility:'',  
        cardImages:[],
        modalImages: [],
        available: this.membership.capacity - this.calculateJoined(),
        popoverShow:false,


        points: 0,
        capacity: this.membership.capacity,

        days: [7],
        isBgGreen: false,
        subscriptionFinished: false,

    }
  },

}
</script>

<style>

</style>